<template>
  <div>
    <ServiceHistoryTable
      :source="source"
      :filters="filters"
      :customer-id="customerId"
      :address="address"
      flat
    >
    </ServiceHistoryTable>
  </div>
</template>

<script setup lang="ts">
import { Address } from "@/typings/address";
import ServiceHistoryTable from "./ServiceHistoryTable.vue";

defineProps({
  source: {
    type: String,
    default: ""
  },
  filters: {
    type: Array,
    default: () => []
  },
  customerId: {
    type: Number,
    default: null
  },
  address: {
    type: Object as () => Address,
    default: null
  }
});
</script>
